import { getEnv } from "@/lib/env";
import { Spinner } from "@heroui/spinner";
import { Trans } from "@lingui/react";
import { brandConfig } from "@nitro-ape/shared/lib/brand-config";
import LoginLinks from "./LoginLinks";

type LoginPageContentProps = {
  isLoading: boolean;
  onLogin: () => void;
};

const LoginPageContent = ({ isLoading, onLogin }: LoginPageContentProps) => {
  return (
    <div className="relative min-h-screen w-screen bg-[#0B0B11]">
      <img
        alt="bg-visual"
        src={brandConfig(getEnv).loginBackgroundImagePath}
        className="absolute left-0 top-0 z-0 hidden h-full object-cover object-left md:block"
      />
      <section className="flex min-h-screen w-screen flex-col items-center justify-center overflow-hidden pb-[32px] md:pb-[47px]">
        <main className="z-10 flex w-full max-w-[95vw] flex-col items-center gap-5 px-4 md:max-w-[600px] md:gap-7 md:px-0">
          <img
            alt="Logo"
            src={brandConfig(getEnv).logoImagePath}
            width={160}
            height={45}
            className="mb-2 mt-2 md:h-[73px] md:w-[261px]"
          />
          <h1 className="font-alliance mt-[-2px] text-center text-2xl font-medium leading-[1.2] text-white md:text-[35px]">
            <Trans
              id="login.heroTitle"
              message="trade like nobody's watching"
              comment="Main headline on the login page."
            />
          </h1>
          <p className="font-inter mb-2 max-w-[90vw] text-center text-sm font-medium leading-[1.21] text-[#686F83] md:max-w-[270px] md:text-[16px]">
            <Trans
              id="login.heroSubtitle"
              message="Connect to start trading instantly"
              comment="Subtitle encouraging the user to connect their account."
            />
          </p>
          <div className="mb-3 flex w-full flex-col justify-center gap-2">
            <LoginButton isLoading={isLoading} onClick={onLogin}>
              <span className="font-alliance text-base font-semibold md:text-[18px]">
                <Trans
                  id="login.connectWallet"
                  message="Connect Wallet"
                  comment="Button label for Privy login."
                />
              </span>
            </LoginButton>
          </div>
          <LoginLinks />
        </main>
      </section>
    </div>
  );
};

type LoginButtonProps = {
  onClick: () => void;
  isLoading: boolean;
  children: React.ReactNode;
};

const LoginButton = (props: LoginButtonProps) => {
  const base =
    "flex h-12 w-full md:h-[86px] flex-row items-center justify-center gap-3 rounded-[18px] md:rounded-[25px] transition-colors bg-[#1F1F2B] hover:bg-[#2D2D3D]";

  return (
    <button
      className={base}
      disabled={props.isLoading}
      onClick={props.onClick}
      type="button"
    >
      {props.isLoading ? (
        <Spinner color="white" size="md" />
      ) : (
        <div className="flex items-center gap-3">{props.children}</div>
      )}
    </button>
  );
};

export default LoginPageContent;
